import {Box, Card, CardContent, CardHeader, Modal, Slide} from "@mui/material";
import InputForm from "../../components/form/InputForm";
import React from 'react';
import {ErrorHandler} from "../../utils/ErrorHandler";
import {useSnackbar} from "notistack";
import GenericAddItem from "./GenericAddItem";

const style = {
  margin: '15px auto',
  width: 400,
}

export default function GenericAddModal({ inputs, open, handleModalClose, createAction, onCreate }) {

  return (
      <Modal open={open} onClose={handleModalClose} sx={{ overflow: 'auto' }}>
        <Slide in={open}>
          <Box sx={style}>
            <GenericAddItem inputs={inputs} header="Add" createAction={createAction} onCreate={onCreate} />
          </Box>
        </Slide>
      </Modal>
  )
}